import React from "react";
import { Notifications } from "@mui/icons-material";
import { Badge, IconButton, Box } from "@mui/material";
import { observer } from "mobx-react-lite";

interface NotificationBellProps {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  unreadCount?: number;
}

export const NotificationBell = observer(
  ({ onClick, unreadCount = 0 }: NotificationBellProps) => {
    return (
      <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
        <IconButton
          onClick={onClick}
          color="inherit"
          sx={{
            padding: 0,
            backgroundColor: "transparent !important",
            marginTop: "-2px",
          }}
          aria-label="notifications"
        >
          <Badge
            badgeContent={unreadCount}
            max={99}
            sx={{
              "& .MuiBadge-badge": {
                backgroundColor: "primary.main",
                color: "white",
                fontSize: "0.625rem",
                minWidth: "18px",
                height: "18px",
                padding: "0 4px",
              },
            }}
          >
            <Notifications sx={{ fontSize: "1.75rem" }} />
          </Badge>
        </IconButton>
      </Box>
    );
  }
);
